import { create } from 'zustand'
import { useLiffToken } from '@/app/store'
import { persist } from 'zustand/middleware'
import { reportError } from '@/app/utils/functions'
import axios from 'axios'

type UserStore = {
    data: any
    setData: (data: any) => void
    getData: () => void
}
const useUser = create<UserStore>()(
    persist(
        (set) => ({
            data: null as UserStore["data"],
            setData: (data: any) => set({ data }),
            getData: () => {
                axios.get('/api/account')
                .then((res) => {
                    // console.log(res.config.url, res.data)
                    set({ data: res.data })
                })
                .catch((err) => {
                    // console.log(err.config?.url, err)
                    reportError(err, true)
                    set({ data: false })
                })
            }
        }),
        {
            name: 'user',
            partialize: (state) => ({
                data: state.data
            })
            // onRehydrateStorage: (state) => {
            //     return (state) => {
            //         console.log('Rehydrating user state', state)
            //     }
            // }
        }
    )
)
const unsub = useLiffToken.subscribe((state) => {
    if (state.token) {
        useUser.getState().getData()
        unsub()
    }
})

export default useUser
